import type { BlockAudio } from 'shared-types';

type LocaleData = BlockAudio['locales'][string];

const defaultBlockData = {};

const translatable: LocaleData['translatable'] = {};
const defaultLocaleData: LocaleData = { file: null, translatable };

const localePlaceholders = { file: '{{ locales.file }}' as const };

export const defaults = {
  defaultBlockData,
  defaultLocaleData,
  localePlaceholders
};

export const blockAudioData: BlockAudio = {
  ...defaultBlockData,
  ...localePlaceholders,
  locales: new Proxy({} as BlockAudio['locales'], {
    get: (locales, languageVersion: string) => {
      return (locales[languageVersion] = defaultLocaleData);
    }
  })
};
